<template>
  <el-container>
    <el-header>
      <navmenu/>
    </el-header>
    <el-main>
      <div class="block">
        <el-carousel trigger="click" height="460px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgList" :key="item.name">
            <div class="pic_item">
              <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" />
              <h3>{{item.title}}</h3>
              <p>{{item.detail}}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
        
      </div>
      <div class="agileManagement">
        <div class="hadoop">
          <ul>
            <li class="icon_a"><a href="#/hadoop/beanstalk">Beanstalk企业研发管理平台</a></li>
            <li class="icon_b"><a href="#/hadoop/bigdataPlatform">大数据测试平台</a></li>
            <li class="icon_c actived"><a href="#/hadoop/agileManagement">敏捷管理咨询</a></li>
            <li class="icon_d"><a href="#/hadoop/qualityManagement">质量管理咨询</a></li>
          </ul>
        </div>
        <div class="share">
          <div style="height:45px;width:415px;margin:0 auto;"><h2>敏捷管理咨询</h2></div>
          <span></span>
        </div>
        <div class="agileManagement-1">
          <div class="view-tip">
            <p class="title">助力企业数字化转型</p>
            <div class="detail">
              <p>数字化转型旨在借助数字世界里强大的可连接、可汇聚和可推演的能力来进行产品、业务和商业模式创新，以更低的成本、更高的效率为客户提供更好的服务和体验。它涉及企业文化、
                组织流程、商业模式和人员能力的蜕变。</p>
              <p>对企业和组织而言数字化转型是一个不断探索、追求卓越的过程，而我们除了提供一系列技术链接创新，例如大数据和分析、可视化、物联网等，我们更提供了配套的、且有效的敏捷
                实践，以帮助企业实现：</p>
              <ul>
                <li>打通端到端全流程协作；</li>
                <li>绘制清晰的客户旅程；</li>
                <li>更好地了解客户，在正确的时间通过正确的渠道提供正确的产品；</li>
                <li>提供互联产品与服务方案；</li>
                <li>满足新客户(新市场)需求的能力；</li>
                <li>让业务研发更有节奏感；</li>
                <li>多渠道的组织结构和协作；</li>
                <li>促进与合作伙伴相互协作。</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="agileManagement-2">
          <div class="view-tip">
            <p class="title">一站式敏捷教练咨询服务</p>
            <div class="detail">
              <p style="margin-top:-10px;margin-bottom:5px">敏捷教练是帮助企业、组织以及团队导入敏捷实践、文化的布道者、带教者，通过落地各种敏捷实践、工具，助力企业实现数字化转型，并构建数字化敏捷高效团队。帮助个人、团队、
                组织少走弯路，是提升组织绩效的加速器，最终还是为了在复杂动荡的环境能“最短时间内实现最高业务价值”。并一起探索出一条“大道”。</p>
              <p>与传统咨询顾问不同，敏捷教练不但具备扎实的敏捷理论基础，丰富的落地经验，也需要引导个体与团队建立共创文化，甚至升级思维模式，因此我们的教练不仅全部拥有CSP以上资
                质，更是来源于企业，帮助过项目组解决过实际问题的务实主义者。</p>
              <p>我们根据项目团队的不同，量身定制敏捷及辅导咨询方案落地，从评估访谈、方案编写制定到实践落地，再到内部人员成长，我们拥有成熟的一站式教练体系，帮助企业快速上手。敏
                捷教练通常的服务模式是通过短期的全职现场指导（从1周到数个迭代），带领团队跨越各种敏捷开发过程中的障碍。</p>
              <p>调整组织结构设计以支持敏捷过程是成功的一个关键因素。在获得企业许可和支持的前提下，我们会深入调研组织结构中的问题，提供多种优化方案功企业选择。</p>
            </div>
          </div>
        </div>
        <div class="agileManagement-3">
          <div class="view-tip">
            <p class="title">团队级敏捷实践落地</p>
            <div class="detail">
              <p>我们的敏捷教练不仅全部拥有CSP以上资质，扎实的敏捷基础，更是来源于企业，帮助过项目组解决过实际问题的务实主义者。我们在观察团队时，经常发现：<br>
                1、团队自己落地敏捷实践容易留其形，却偏离的敏捷的本意。<br>
                2、非专业的教练落地时敏捷实践又过于教条，偏离项目的目标。<br>
                因此我们长期的指导经验的积累，构建了从评估访谈、方案编写制定到实践落地，再到内部人员成长，我们拥有成熟的一站式教练体系，务实求真地在敏捷框架中，探索和设计是适合
                团队目标的敏捷实践集。</p>
              <p>真正帮助过不少客户，实施有效的敏捷。我们通常采用和覆盖的敏捷框架和实践，如下：<br>
                涉及面可以涵盖团队的商业模式和价值主张、精益创业、设计思维、Scrum迭代活动、XP工程实践、Kanban看板、Lean实践、领导力、组织转型等。</p>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer>
      <footerMenu/>
    </el-footer>
  </el-container>
</template>

<script>
import navmenu from '../../components/navmenu.vue';
import footerMenu from '../../components/footer.vue';
export default {
  components: { navmenu,footerMenu },
  data(){
    return{
      imgList:[
        {
          name: "banner1",
          title:'大数据及效能',
          detail:'Big data & efficiency',
          src: require("../../../public/hadoopImg/dashuju1.png"),
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.share{
  padding:80px 0 60px 0;
  span{
    height: 3px;
    width: 44px;
    display: inline-block;
    background-color: #C5C5C5;
  }
}

.block{
  position: relative;
  .pic_item {
    position: relative;
    height: 100%;
    h3{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 132px;        
      font-size: 60px;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:moveh3 3s infinite;
      // animation-iteration-count:1;
      @keyframes moveh3{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
      @-webkit-keyframes moveh3 /*Safari and Chrome*/{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
    }      
    p{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 242px;        
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:movep 3s infinite;
      @keyframes movep{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
      }
      @-webkit-keyframes movep /*Safari and Chrome*/{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
      }
    }      
  }
  .pic_item:hover{
    cursor: pointer;
  }
}

.view-tip{
    width: 1200px;   
    margin: 0 auto;
    margin-bottom: 40px;
    .title{
      height: 33px;
      text-align: left;
      font-size: 24px;
      font-weight: bold;
      margin: 0 0 10px;
      padding-left: 10px;
      border-left: solid 3px #1E8DD4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre !important;
    }
    .detail{
      margin-top: 32px;
      text-align: left;
      font-size: 16px;
      line-height: 32px;
      color: #666;
      padding-left: 13px;
      p{
        margin-top:-3px
      }
      span{
        font-size: 18px;
        font-weight: bold;
        line-height: 20px;
        margin-bottom: 10px;
      }
      ul{
        list-style-type: disc;
        margin-left: 18px;
        li{
          // padding-bottom: 5px;
        }
      }
    }
  }


.agileManagement{
  height: 1719px;
  position: relative;
  .hadoop{
    position: absolute;
    width: 1200px;
    height: 150px;
    left:50%;
    transform: translateX(-50%);
    z-index: 99;
    margin-top:-75px ;
    background: url(../../../public/hadoopImg/hadoop.png) center;
    ul{
      margin-top: 60px;
      display: flex;
      justify-content: space-around;
      text-align: center;
      li{height: 40px;line-height: 40px;}
      .icon_a{
        background: url("../../../public/hadoopImg/icon_a.png") no-repeat;
      }
      .icon_a:hover{
        background: url("../../../public/hadoopImg/icon_a1.png") no-repeat;
      }
      .icon_b{
        background: url("../../../public/hadoopImg/icon_b.png") no-repeat;
      }
      .icon_b:hover{
        background: url("../../../public/hadoopImg/icon_b1.png") no-repeat;
      }
      .icon_c{
        background: url("../../../public/hadoopImg/icon_c.png") no-repeat;
      }
      .actived,.icon_c:hover{
        background: url("../../../public/hadoopImg/icon_c1.png") no-repeat;
      }
      .actived a{color: #01619E;}
      .icon_d{
        background: url("../../../public/hadoopImg/icon_d.png") no-repeat;
      }
      .icon_d:hover{
        background: url("../../../public/hadoopImg/icon_d1.png") no-repeat;
      }
      li:hover{
        color: #01619E;
      }
    }
    a{
      color: #333;
      padding-left: 50px;
    }
    a:hover,a:active{
      color: #01619E;
    }
  }
  .agileManagement-1{
    height: 543px;
  }
  .agileManagement-2{
    height: 465px;
    background: #F8F9FB;
    .view-tip{
      padding-top: 60px;
    }
  }
  .agileManagement-3{
    height: 451px;
    .view-tip{
      padding-top: 60px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Hadoop/agileManagement.vue